import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AlbumModel} from "../../models/album.model";
import {UserTagModel} from "../../models/user-tag.model";
import {FormControl} from "@angular/forms";
import {Http} from "@angular/http";
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {ActivatedRoute} from "@angular/router";
import {switchMap} from "rxjs/operators";
import {Subscription} from "rxjs";
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-albums',
  templateUrl: './albums.component.html',
  styleUrls: ['./albums.component.css']
})
export class AlbumsComponent implements OnInit, OnDestroy {

  albums: AlbumModel[];
  albumsFiltered: AlbumModel[];
  tagToFilter: UserTagModel;
  albumFilter = new FormControl('');
  showAddAlbums = false;
  showOptionsMenu = false;
  tagEditedSubscription: Subscription;
  loading$ = this.loadingService.loading$;

  constructor(private http: Http, private spotifyTagsService: SpotifyTagsService, private route: ActivatedRoute, private loadingService: LoadingService) {
  }

  ngOnInit() {
    this.tagEditedSubscription = this.spotifyTagsService.tagEdited$.subscribe(editedTag => this.tagToFilter = editedTag);
    this.route.paramMap.pipe(
      switchMap(params => {
        return this.spotifyTagsService.getAlbums(Number(params.get('tagId')));
      })
    ).subscribe(response => {
      this.albums = response.albums;
      this.albumsFiltered = response.albums;
      this.tagToFilter = response.tag;
      this.albumFilter.valueChanges.subscribe(value => {
        if (!value) {
          this.albumsFiltered = this.albums;
        } else {
          this.albumsFiltered = this.albums.filter(album => album.name.toLowerCase().includes(value.toLowerCase()) ||
            album.artist.toLowerCase().includes(value.toLowerCase()));
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.tagEditedSubscription.unsubscribe();
  }

  updateAlbums() {
    this.showAddAlbums = false;
    this.showOptionsMenu = false;
    this.spotifyTagsService.getAlbums(this.tagToFilter ? this.tagToFilter.tagId : null).subscribe(response => {
      this.albums = response.albums;
      this.albumsFiltered = response.albums;
    });
  }

  openInSpotify(album: AlbumModel) {
    window.location.href = album.uri;
  }

  openAddAlbums() {
    this.showAddAlbums = true;
  }

  toggeOptionsMenu() {
    event.stopPropagation();
    this.showOptionsMenu = !this.showOptionsMenu;
  }

  @HostListener('click')
  hideOptionsMenuAgain() {
    this.showOptionsMenu = false;
  }

  @HostListener('document:click')
  hideOptionsMenu() {
    this.showOptionsMenu = false;
  }

  editTag() {
    this.spotifyTagsService.passEditTag(this.tagToFilter);
    this.showOptionsMenu = false;
  }

  deleteTag() {
    this.spotifyTagsService.passDeleteTag(this.tagToFilter);
    this.showOptionsMenu = false;
  }

  synchronise() {
    this.spotifyTagsService.syncWithSpotify().subscribe(() => {
      this.updateAlbums();
    });
  }
}
